import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faArrowLeft, 
  faBuilding, 
  faLocationDot, 
  faMoneyBillWave,
  faGraduationCap,
  faCalendarDays,
  faBriefcase,
  faFile,
  faCircleInfo,
  faCheck,
  faRobot,
  faChartPie,
  faStar,
  faCircleCheck,
  faTriangleExclamation,
  faNetworkWired,
  faVolumeHigh,
  faVolumeXmark,
  faRocket,
  faArrowRight,
  faHandshake,
  faCompass,
  faBookOpen,
  faChartLine,
  faComments,
  faFileCircleCheck,
  faLightbulb,
  faCircleQuestion,
  faUser,
  faBrain,
  faKeyboard,
  faPaperPlane,
  faMicrophone,
  faImage,
  faCamera,
  faUserGraduate,
  faBullseye,
  faCheckCircle,
  faTags,
  faComment,
  faClipboardCheck,
  faChartSimple,
  faIdCard,
  faSitemap,
  faHeart,
  faMapMarkerAlt,
  faRoad,
  faBook,
  faCertificate,
  faCode,
  faVideo,
  faHourglassHalf,
  faFire,
  faSpinner,
  faServer,
  faMobile,
  faBug,
  faTools,
  faHeadset,
  faDatabase,
  faProjectDiagram,
  faCrown,
  faGamepad,
  faCalculator,
  faLink,
  faCloud,
  faMicrochip,
  faMemory,
  faBolt,
  faBroadcastTower,
  faWrench,
  faPhone,
  faWifi,
  faShoppingCart,
  faChartBar,
  faStore,
  faPen,
  faUsers,
  faShareAlt,
  faPalette,
  faHome,
  faCube,
  faTshirt,
  faMagic,
  faAward,
  faDesktop,
  faCopyright,
  faUserTie,
  faClipboardList,
  faBalanceScale,
  faChalkboardTeacher,
  faMoneyCheckAlt,
  faFileInvoice,
  faCoins,
  faPiggyBank,
  faChartArea,
  faShieldAlt,
  faCogs,
  faIndustry,
  faHardHat,
  faFlask,
  faCut,
  faCar,
  faCarSide,
  faLeaf,
  faHammer,
  faBox,
  faTruck,
  faChild,
  faSchool,
  faMicroscope,
  faLaptop,
  faBed,
  faMapMarkedAlt,
  faUtensils,
  faUmbrellaBeach,
  faPaintBrush,
  faDraftingCompass,
  faCity,
  faEye,
  faChargingStation,
  faCreditCard,
  faBullhorn,
  faLandmark,
  faAd,
  faNewspaper,
  faUserNurse,
  faUserMd,
  faSpa,
  faPills,
  faDna,
  faVial,
  faStethoscope,
  faYinYang,
  faPaw,
  faHospital,
  faUniversity,
  faHandHoldingUsd,
  faShield,
  faSearch,
  faLanguage,
  faGavel,
  faUsersCog,
  faChess,
  faRecycle,
  faSeedling,
  faSolarPanel,
  faWater,
  faMountain,
  faExpandArrowsAlt,
  faMicrophoneAlt,
  faEdit,
  faFilm,
  faVolumeUp,
  faWarehouse,
  faShippingFast,
  faRunning,
  faDumbbell,
  faSmile,
  faMusic
} from '@fortawesome/free-solid-svg-icons'

import {
  faClock,
  faSmileBeam,
  faCircle
} from '@fortawesome/free-regular-svg-icons'

import {
  faWeixin,
  faWeibo,
  faQq,
  faGithub
} from '@fortawesome/free-brands-svg-icons'

// 添加图标到库
library.add(
  faArrowLeft,
  faBuilding,
  faLocationDot,
  faMoneyBillWave,
  faGraduationCap,
  faCalendarDays,
  faBriefcase,
  faFile,
  faCircleInfo,
  faCheck,
  faRobot,
  faChartPie,
  faStar,
  faCircleCheck,
  faTriangleExclamation,
  faNetworkWired,
  faVolumeHigh,
  faVolumeXmark,
  faRocket,
  faArrowRight,
  faHandshake,
  faCompass,
  faBookOpen,
  faChartLine,
  faComments,
  faFileCircleCheck,
  faLightbulb,
  faCircleQuestion,
  faUser,
  faBrain,
  faKeyboard,
  faPaperPlane,
  faMicrophone,
  faImage,
  faCamera,
  faUserGraduate,
  faBullseye,
  faCheckCircle,
  faTags,
  faComment,
  faClipboardCheck,
  faChartSimple,
  faIdCard,
  faSitemap,
  faHeart,
  faMapMarkerAlt,
  faRoad,
  faBook,
  faCertificate,
  faCode,
  faVideo,
  faHourglassHalf,
  faFire,
  faSpinner,
  faServer,
  faMobile,
  faBug,
  faTools,
  faHeadset,
  faDatabase,
  faProjectDiagram,
  faCrown,
  faGamepad,
  faCalculator,
  faLink,
  faCloud,
  faMicrochip,
  faMemory,
  faBolt,
  faBroadcastTower,
  faWrench,
  faPhone,
  faWifi,
  faShoppingCart,
  faChartBar,
  faStore,
  faPen,
  faUsers,
  faShareAlt,
  faPalette,
  faHome,
  faCube,
  faTshirt,
  faMagic,
  faAward,
  faDesktop,
  faCopyright,
  faUserTie,
  faClipboardList,
  faBalanceScale,
  faChalkboardTeacher,
  faMoneyCheckAlt,
  faFileInvoice,
  faCoins,
  faPiggyBank,
  faChartArea,
  faShieldAlt,
  faCogs,
  faIndustry,
  faHardHat,
  faFlask,
  faCut,
  faCar,
  faCarSide,
  faLeaf,
  faHammer,
  faBox,
  faTruck,
  faChild,
  faSchool,
  faMicroscope,
  faLaptop,
  faBed,
  faMapMarkedAlt,
  faUtensils,
  faUmbrellaBeach,
  faPaintBrush,
  faDraftingCompass,
  faCity,
  faEye,
  faChargingStation,
  faCreditCard,
  faBullhorn,
  faLandmark,
  faAd,
  faNewspaper,
  faUserNurse,
  faUserMd,
  faSpa,
  faPills,
  faDna,
  faVial,
  faStethoscope,
  faYinYang,
  faPaw,
  faHospital,
  faUniversity,
  faHandHoldingUsd,
  faShield,
  faSearch,
  faLanguage,
  faGavel,
  faUsersCog,
  faChess,
  faRecycle,
  faSeedling,
  faSolarPanel,
  faWater,
  faMountain,
  faExpandArrowsAlt,
  faMicrophoneAlt,
  faEdit,
  faFilm,
  faVolumeUp,
  faWarehouse,
  faShippingFast,
  faRunning,
  faDumbbell,
  faSmile,
  faMusic,
  faClock,
  faSmileBeam,
  faCircle,
  faWeixin,
  faWeibo,
  faQq,
  faGithub
)

export default {
  install: (app) => {
    app.component('fa-icon', FontAwesomeIcon)
  }
} 